import { useQuery } from '@tanstack/react-query';

import { mockList } from '@/lib/mock/db';

/**
 * 관리자가 저장한 메뉴 라벨·순서·구조.
 *
 * v1 은 브라우저에서 `supabase.from('menu_settings').select('*')` 로 테이블을 직접 읽었다.
 * v2 는 백엔드의 `GET /api/v1/menu-settings` 가 내려줄 자리이며, 지금은 다른 화면들과 같이 목 저장소를 본다 —
 * 메뉴 관리 화면이 이 값을 **쓰기도** 하는데 저장 엔드포인트가 아직 없기 때문이다.
 * 읽기만 붙여 두면 저장 버튼이 아무 일도 하지 않는 화면이 된다.
 *
 * 비어 있으면 `mergeMenuConfig` 가 기본 골격을 그대로 쓰므로 메뉴는 항상 뜬다.
 */
export const menuSettingsQueryKey = ['menu-settings'] as const;

export function useMenuSettings() {
  return useQuery({
    queryKey: menuSettingsQueryKey,
    queryFn: () => mockList('menuSettings'),
    staleTime: 10 * 60_000,
    retry: false,
  });
}
